export default require.context('./components/.exported_teleporthq/groups wip-react/public/playground_assets');
